import gql from 'graphql-tag';

export const REGISTRY_PROJECT_MEMBERS_QUERY = gql`
  query RegistryProjectMembers($entityName: String!, $projectName: String!) {
    project(entityName: $entityName, name: $projectName) {
      id
      name
      user {
        id
        name
        username
        photoUrl
        email
        accountType
      }
      members {
        id
        username
        name
        photoUrl
        email
        accountType
        role {
          ID
          name
        }
        projectRoleIsInherited
      }
      teamMembers {
        role {
          ID
          name
        }
        team {
          id
          name
          photoUrl
          memberCount
          members {
            id
            name
            photoUrl
            accountType
          }
        }
      }
    }
  }
`;

export const BATCH_REGISTRY_VIEWER_MEMBERSHIP_QUERY = gql`
  query BatchRegistryViewerMembership(
    $entityName: String!
    $viewerID: ID!
    $projectIDs: [ID!]!
  ) {
    projects(entityName: $entityName, projectIDs: $projectIDs) {
      edges {
        node {
          id
          member(id: $viewerID) {
            id
            name
          }
          teamMembers {
            team {
              id
              member(id: $viewerID) {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;
